<template>
  <ul class="navbar-nav mr-auto">
    <li class="nav-item" v-if="session.profile">
      <button title="logout" class="btn btn-primary" @click="logout()"><i class="fa fa-id-badge" aria-hidden="true"></i>
        {{ session.profile.displayName }}
      </button>
    </li>
    <li v-else class="nav-item ml-auto">
      <button class="btn btn-primary" @click="authorize()">Login</button>
    </li>
  </ul>

</template>

<script>
import { mapState } from "vuex";
export default {
  name: "auth-login",
  computed: mapState(["session", "store"]),
  methods: {
    authorize() {
      window.location.href = "/api/auth";
    },
    logout() {
      window.location.href = "/api/auth/logout";
    }
  },
  beforeCreate: function() {
    this.$store.dispatch("loadSession");
  }
};
</script>
